import { useState } from "react";
import AddressModal from "./AddressModal";
import AddAddressModal from "./AddAddressModal";

export default function ShippingInfo() {
    const [openAddressModal, setOpenAddressModal] = useState(false);
    const [selectedAddress, setSelectedAddress] = useState(null);
    const [openAddAddressModal, setOpenAddAddressModal] = useState(false);

    const handleCloseAddAddress = () => {
        setOpenAddAddressModal(false);
        setOpenAddressModal(true);   // mở lại AddressModal
    };

    return (
        <>
            <div className="MuiPaper-root styles_root__Bo4EW MuiPaper-elevation0 MuiPaper-rounded">
                <h1 className="styles_title__jiXAZ">
                    Thông tin giao hàng
                    <button
                        className="MuiButtonBase-root MuiButton-root MuiButton-text styles_add_new_button__2VFAd"
                        type="button"
                        tabIndex={0}
                    >
                        <span className="MuiButton-label" onClick={() => setOpenAddressModal(true)}>Sửa</span>
                    </button>
                </h1>

                <div className="MuiGrid-root MuiGrid-container">
                    <div className="MuiGrid-root styles_groupInfo__WP9N1 MuiGrid-item MuiGrid-grid-xs-12">

                        {/* Item 1 */}
                        <div className="styles_item__HGoUe">
                            <div className="flex items-center h-[20px]">
                                <span
                                    style={{
                                        boxSizing: "border-box",
                                        display: "inline-block",
                                        overflow: "hidden",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: 0,
                                        margin: 0,
                                        padding: 0,
                                        position: "relative",
                                        maxWidth: "100%"
                                    }}
                                >
                                    <span
                                        style={{
                                            boxSizing: "border-box",
                                            display: "block",
                                            width: "initial",
                                            height: "initial",
                                            background: "none",
                                            opacity: 1,
                                            border: 0,
                                            margin: 0,
                                            padding: 0,
                                            maxWidth: "100%"
                                        }}
                                    >
                                        <img
                                            alt=""
                                            aria-hidden="true"
                                            src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2716%27%20height=%2716%27/%3e"
                                            style={{
                                                display: "block",
                                                maxWidth: "100%",
                                                width: "initial",
                                                height: "initial",
                                                background: "none",
                                                opacity: 1,
                                                border: 0,
                                                margin: 0,
                                                padding: 0
                                            }}
                                        />
                                    </span>

                                    <img
                                        src="https://cdn-web-next.thuocsi.vn/icons/checkout/Person.svg"
                                        decoding="async"
                                        style={{
                                            position: "absolute",
                                            inset: 0,
                                            boxSizing: "border-box",
                                            padding: 0,
                                            border: "none",
                                            margin: "auto",
                                            display: "block",
                                            width: 0,
                                            height: 0,
                                            minWidth: "100%",
                                            maxWidth: "100%",
                                            minHeight: "100%",
                                            maxHeight: "100%"
                                        }}
                                    />
                                </span>
                            </div>

                            <h6 className="MuiTypography-root MuiTypography-h6">
                                Nhà thuốc Vũ Huy
                            </h6>
                        </div>

                        {/* Item 2 */}
                        <div className="styles_item__HGoUe">
                            <div>
                                <span
                                    style={{
                                        boxSizing: "border-box",
                                        display: "inline-block",
                                        overflow: "hidden",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: 0,
                                        margin: 0,
                                        padding: 0,
                                        position: "relative",
                                        maxWidth: "100%"
                                    }}
                                >
                                    <span
                                        style={{
                                            boxSizing: "border-box",
                                            display: "block",
                                            width: "initial",
                                            height: "initial",
                                            background: "none",
                                            opacity: 1,
                                            border: 0,
                                            margin: 0,
                                            padding: 0,
                                            maxWidth: "100%"
                                        }}
                                    >
                                        <img
                                            alt=""
                                            aria-hidden="true"
                                            src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2716%27%20height=%2716%27/%3e"
                                            style={{
                                                display: "block",
                                                maxWidth: "100%",
                                                width: "initial",
                                                height: "initial"
                                            }}
                                        />
                                    </span>

                                    <img
                                        src="https://cdn-web-next.thuocsi.vn/icons/checkout/Phone.svg"
                                        decoding="async"
                                        style={{
                                            position: "absolute",
                                            inset: 0,
                                            margin: "auto",
                                            display: "block",
                                            minWidth: "100%",
                                            maxWidth: "100%",
                                            minHeight: "100%",
                                            maxHeight: "100%"
                                        }}
                                    />
                                </span>
                            </div>

                            <h6 className="MuiTypography-root MuiTypography-h6">
                                0932115595
                            </h6>
                        </div>

                        {/* Item 3 */}
                        <div className="styles_item__HGoUe">
                            <div>
                                <span
                                    style={{
                                        boxSizing: "border-box",
                                        display: "inline-block",
                                        overflow: "hidden",
                                        width: "initial",
                                        height: "initial",
                                        background: "none",
                                        opacity: 1,
                                        border: 0,
                                        margin: 0,
                                        padding: 0,
                                        position: "relative",
                                        maxWidth: "100%"
                                    }}
                                >
                                    <span
                                        style={{
                                            boxSizing: "border-box",
                                            display: "block",
                                            width: "initial",
                                            height: "initial"
                                        }}
                                    >
                                        <img
                                            alt=""
                                            aria-hidden="true"
                                            src="data:image/svg+xml,%3csvg%20xmlns=%27http://www.w3.org/2000/svg%27%20version=%271.1%27%20width=%2716%27%20height=%2716%27/%3e"
                                        />
                                    </span>

                                    <img
                                        src="https://cdn-web-next.thuocsi.vn/icons/checkout/Check_In_Pin.svg"
                                        decoding="async"
                                        style={{ position: "absolute", inset: 0, margin: "auto" }}
                                    />
                                </span>
                            </div>

                            <h6 className="MuiTypography-root MuiTypography-h6">
                                27 Nguyễn Hữu Trí, ấp 57, Xã Tân Nhựt, Huyện Bình Chánh, Thành phố Hồ Chí Minh
                            </h6>
                        </div>

                    </div>
                </div>

            </div>
            <AddressModal
                open={openAddressModal}
                onClose={() => setOpenAddressModal(false)}
                onOpenAdd={() => {
                    setOpenAddressModal(false);
                    setOpenAddAddressModal(true);
                }}
            />
            <AddAddressModal
                open={openAddAddressModal}
                onClose={handleCloseAddAddress}
                onSave={(form) => {
                    console.log("Address saved:", form);

                    // đóng Add
                    setOpenAddAddressModal(false);

                    // mở lại AddressModal
                    setOpenAddressModal(true);
                }}
            />
        </>
    );
}

